import React from 'react';

const GrayShadowBox = ({ children, className = '' }) => {
    return (
        <div className={`bg-gray-50 rounded-lg p-6 shadow-md max-w-7xl mx-auto ${className}`}>
            {children}
        </div>
    );
};

export default GrayShadowBox;
